<template lang="pug">
  #section6
    #s6s1.group.container-fluid
      img.oval.top(src="/assets/img/chapter1/oval-yellow.png")
      img.oval.mid-1(src="/assets/img/chapter1/oval-yellow.png")
      img.oval.bottom(src="/assets/img/chapter1/oval-pink.png")
      #s6s1b1.row.justify-content-center.mt-5
        .fake-header
        .col-11.col-sm-10.col-md-9.text-center
          h2.py-0.uppercase.mb-5 ¿Cómo es el COVID-19 
            span.purple-title.bolder diferente de la influenza?
        .col-11.col-md-9.col-lg-7
          img.img-fluid.mb-3(src="/assets/img/chapter1/covid-group.png")
          p.text-center.large
            span.bolder.larger El COVID-19 es más contagioso que la influenza: 
            | Una persona enferma de COVID19 puede infectar de 2 a 2.5 personas más, 
        .col-11.col-md-9.col-lg-7.pause-t
          img.img-fluid.mb-3(src="/assets/img/chapter1/influenza.png")
          p.text-center.large 
            span.bolder.larger mientras que una persona con influenza puede infectar a 1.4 personas.
        .col-11.col-md-9.col-lg-7.pause-t
          img.img-fluid.mb-3(src="/assets/img/chapter1/stage3-oval.png")
          p.text-center.large 
            span.largest.bolder.subtitle.purple-title Más gente con COVID-19 llega a estado severo: 
            span.bolder 15% de los pacientes con COVID-19 llegan a estado severo, y el 5% requiere ventilación. 
            | Mientras que sólo del 1%  al 2% de los casos de influenza llegan a hospitalización. 
      #s6s1b2.row.mt-5.justify-content-center
        .col-11.col-md-9.col-lg-7.pause-t
          img.img-fluid.mb-3(src="/assets/img/chapter1/kid.png")
          p.text-center.large 
            span.bolder.largest.subtitle.purple-title Las poblaciones en riesgo son distintas: 
            | Mientras con la 
            span.bold influenza 
            | quienes  corren riesgo de llegar a estados críticos son niños, mujeres embarazadas, ancianos y personas con inmunosupresión, 
      #s6s1b3.row.mt-5.justify-content-center
        .col-11.col-md-9.col-lg-7.pause
          img.img-fluid.mb-3(src="/assets/img/chapter1/old.png")
          p.text-center.large con el 
            span.bolder COVID19 
            | son ancianos y personas con enfermedades preexistentes como la diabetes, hipertensión u obesidad. 
        .fake-footer
</template>

<script>
export default {
  name: "Section6"
};
</script>
<style lang="scss" scoped>
#section6 {
  min-height: 200vh;
  #s6s1 {
    padding-top: 40vh;
    padding-bottom: 30vh;
    overflow: hidden;
  }
  .fake-header {
    @include fakinH(1vh, 0%);
  }
  .fake-footer {
    @include fakinF(1vh, 0%);
  }
  .pause {
    margin: 16rem auto;
  }
  .pause-t {
    margin-top: 16rem;
  }
  .pause-b {
    margin-bottom: 16rem;
  }
  img {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .row p {
    margin-left: auto;
    margin-right: auto;
    max-width: 950px;
  }
  .bullet {
    position: absolute;
    right: 10%;
    top: -5%;
    border-radius: 50%;
    padding: 0.5rem;
    width: 2.5rem;
    height: 2.5rem;
  }
  .oval.top {
    top: -3%;
    left: -93%;
  }
  .oval.mid-1 {
    top: 24%;
    left: 80%;
  }
  .oval.bottom {
    bottom: 3%;
    left: -90%;
  }
}

@media (min-width: 768px) {
  #section6 {
    .oval.bottom {
      bottom: 5%;
      left: -55%;
    }
    .oval.mid-1 {
      display: none;
    }
  }
}

@media (min-width: 1400px) {
  #section6 {
    .oval.top {
      left: -29%;
      top: 2%;
      transform: rotate(39deg);
    }
  }
}
</style>
